/** Presets para Gmail / Google Workspace (comercial@dominio.com). */
export const GMAIL_SMTP_HOST = 'smtp.gmail.com';

export const GMAIL_SMTP_PRESET_587 = {
  smtpHost: GMAIL_SMTP_HOST,
  smtpPort: 587,
  smtpSecure: false,
} as const;

export const GMAIL_SMTP_PRESET_465 = {
  smtpHost: GMAIL_SMTP_HOST,
  smtpPort: 465,
  smtpSecure: true,
} as const;

export function normalizeSmtpHostInput(host: string): string {
  const h = host.trim().toLowerCase();
  if (h === 'smtp-gmail.com' || h === 'smtp.googlemail.com') return GMAIL_SMTP_HOST;
  return host.trim();
}

export function isGmailSmtpHost(host: string): boolean {
  return normalizeSmtpHostInput(host).toLowerCase() === GMAIL_SMTP_HOST;
}
